/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Page Header View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PageHeader';

export const mapStateToPropsPageHeader = mapStateToProps;
export const mapDispatchToPropsPageHeader = mapDispatchToProps;

export default connect(
  mapStateToPropsPageHeader,
  mapDispatchToPropsPageHeader
)(View);
